module.exports = __webpack_public_path__ + "static/media/SectionPartners_fire_eye.bc76f906.jpeg";